import { genericAtom } from '../jotai';
export interface DrawerState {
    isOpen?: boolean;
    titleTransCode?: React.ReactNode;
    titleAction?: React.ReactNode;
    content?: JSX.Element | null;
    footer?: JSX.Element | null;
    onClose?: () => void;
    subtitle?: React.ReactNode;
    hideHeader?: boolean;
}

const globalDrawerStateDefault: DrawerState = {
    isOpen: false,
    titleTransCode: undefined,
    titleAction: undefined,
    content: null,
    footer: null,
    onClose: () => { },
    subtitle: undefined,
    hideHeader: false,
};

export const globalDrawerState = genericAtom<DrawerState | null>(globalDrawerStateDefault,
);

